import { BaseDTO } from '../global/base.dto';
import { ContactListDTO } from '../contact/contact-list.dto';

export class PositionDTO extends BaseDTO {

    name: string;

    description: string;

    contacts: Array<ContactListDTO>;

}
